module.exports = __webpack_public_path__ + "static/consenttotreat-d0eebf78cc865eb1a570f0af6b05c4be.pdf";